var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderSymbolIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8317 0.703125H1.99837C1.53814 0.703125 1.16504 1.07622 1.16504 1.53646V14.4531C1.16504 14.9134 1.53814 15.2865 1.99837 15.2865H12.8317C13.2919 15.2865 13.665 14.9134 13.665 14.4531V1.53646C13.665 1.07622 13.2919 0.703125 12.8317 0.703125Z",
    stroke: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 3.82812H8.97917",
    stroke: "#666666",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 6.42969H5.85417",
    stroke: "#666666",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderSymbolIcon);
export default __webpack_public_path__ + "static/media/folder-symbol-icon.1b0e61a96b79ea666247b1750ce7de82.svg";
export { ForwardRef as ReactComponent };